import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TaskService {
	deleteFailed = 'data delete failed'; deleteSuccess = 'data delete success' ; insertFailed = 'data insert failed' ; dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15' ; datainsertedSuccess= 'data inserted success'
	header = new HttpHeaders().set('Content-Type', 'application/json');
	
	constructor(private readonly http : HttpClient) { }

	//tasks

	getDetails(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/tasks`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
  }
  
  addtasks(arrData: any): Observable<any> {
		const headers = this.header
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/tasks/addTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	edittasks(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/tasks/updateTask`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	deletetasks(arrData: any): Observable<any> {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/tasks/deleteTask?p_taskID=${arrData.taskID}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

//subtasks

getsubtaskDetails(task_id): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/tasks/subTask/${task_id}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}



addsubtask(arrData: any): Observable<any> {
	const headers = this.header
	return this.http
		.post(`${environment.baseAPIURL}/api/v1/tasks/addSubTask`, arrData, { headers, responseType: 'text' })
		.pipe(
			tap(_ => this.log(this.datainsertedSuccess)),
			catchError(this.handleError<any>(this.insertFailed))
		);
}

editsubtask(arrData: any): Observable<any> {
	return this.http
		.put(`${environment.baseAPIURL}/api/v1/tasks/updateSubTask`, arrData)
		.pipe(
			tap(_ => this.log(this.datainsertedSuccess)),
			catchError(this.handleError<any>(this.insertFailed))
		);
}

deletesubtask(arrData: any): Observable<any> {
	return this.http
		.delete(`${environment.baseAPIURL}/api/v1/tasks/deleteSubTask/${arrData.subtaskID}`)
		.pipe(
			tap(_ => this.log(this.deleteSuccess)),
			catchError(this.handleError<any>(this.deleteFailed))
		);
}

	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}




}


